import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

export const StyledNavMenuListItem = styled(MenuItem)(({ theme }) => ({
  paddingLeft: theme.spacing(3.5),
  fontWeight: theme.typography.fontWeightMedium,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  transition: '0.5s',
  '&:hover': {
    backgroundColor: '#A08CA0',
  },
  '&.active': {
    backgroundColor: theme.palette.primary.light,
  },
}));

export const StyledNavMenuLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  textDecoration: 'none',
  padding: theme.spacing(2, 1),
  color: theme.palette.common.white,
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.common.white,
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 0),
  },
}));
